import type { ReactNode } from 'react';

/*
  Карточка одного приёма на странице «Характер»: номер, название, идея, живой пример,
  и отдельной строкой — что это даёт. Одинаковая рамка для всех приёмов, чтобы страница
  читалась как список, а не как набор разнородных вставок.
*/

export function Demo({
  n,
  title,
  idea,
  gain,
  children,
}: {
  n: number;
  title: string;
  idea: string;
  gain: string;
  children: ReactNode;
}) {
  return (
    <section className="rounded-lg border border-line bg-card p-5">
      <div className="flex items-baseline gap-2">
        <span className="text-2xs font-semibold text-fg-subtle tabular-nums">{n}</span>
        <h2 className="type-heading text-fg">{title}</h2>
      </div>
      <p className="mt-1 max-w-2xl text-sm text-fg-muted">{idea}</p>
      <div className="mt-5 rounded-md border border-line bg-canvas p-5">{children}</div>
      <p className="mt-3 text-xs text-fg-subtle">
        <span className="font-medium text-fg-muted">Что это даёт. </span>
        {gain}
      </p>
    </section>
  );
}
